import { Api as WebAppApi } from './api/web-app';
import { injectInterceptors } from './interceptors';
import { ApiTimeout, eOneInstance } from './request';

// Note: `export *` instead of `export type *` for enum values
// export type * from './api/web-app';
export * from './api/web-app';
export * from './error';
export { errorCodeSetToBypass } from './interceptors';
export * from './request';

// ColumnType is intentionally NOT re-declared here — it is exported from the
// generated client (./api/web-app) via `export *` above, making that the single
// source of truth (regenerated from the backend C# enum). Do not hand-declare a
// local ColumnType: it shadows the generated one and defeats type-checking (see SC-1071).

// NoDataRunTasksOption enum - matches backend C# enum NoDataRunTasksOption
export enum NoDataRunTasksOption {
  RunAll = 'RunAll',
  RunFailure = 'RunFailure',
  RunSuccess = 'RunSuccess',
  RunNone = 'RunNone',
}

// DataSourceExclusions enum - matches backend C# enum DataSourceExclusions
export enum DataSourceExclusions {
  DoNothing = 'DoNothing',
  ExcludeBlankLines = 'ExcludeBlankLines',
  ExcludeBlankKeys = 'ExcludeBlankKeys',
}

// ScriptOptions is intentionally NOT re-declared here — it is exported from the
// generated client (./api/web-app) via `export *` above, making that the single
// source of truth. Same rationale as ColumnType (SC-1071): a hand-declared local
// enum shadows the generated one via `export *` precedence and silently drifts.
// (NoDataRunTasksOption / DataSourceExclusions above are NOT emitted by the
// generated client, so they are legitimately hand-declared — no shadowing.)

const webAppApi = new WebAppApi({
  baseURL: '/',
  timeout: ApiTimeout.Default,
});

const webAppApiInstance = webAppApi.instance;

injectInterceptors(eOneInstance);
injectInterceptors(webAppApi.instance);

export { webAppApi, webAppApiInstance };
